export const ALL_PERMISSIONS = [
  { permission: 'user:create', description: 'Create new users', category: 'User Management' },
  { permission: 'user:read', description: 'View user information', category: 'User Management' },
  { permission: 'user:update', description: 'Update user information', category: 'User Management' },
  { permission: 'user:delete', description: 'Delete users', category: 'User Management' },
  { permission: 'user:manage_permissions', description: 'Manage user permissions', category: 'User Management' },
  { permission: 'attendance:create', description: 'Create attendance records', category: 'Attendance' },
  { permission: 'attendance:read', description: 'View attendance records', category: 'Attendance' },
  { permission: 'attendance:update', description: 'Update attendance records', category: 'Attendance' },
  { permission: 'attendance:delete', description: 'Delete attendance records', category: 'Attendance' },
  { permission: 'attendance:export', description: 'Export attendance data', category: 'Attendance' },
  { permission: 'attendance:manage_all', description: 'Manage all users attendance', category: 'Attendance' },
  { permission: 'leave:create', description: 'Create leave requests', category: 'Leave Management' },
  { permission: 'leave:read', description: 'View leave requests', category: 'Leave Management' },
  { permission: 'leave:update', description: 'Update leave requests', category: 'Leave Management' },
  { permission: 'leave:delete', description: 'Delete leave requests', category: 'Leave Management' },
  { permission: 'leave:approve', description: 'Approve leave requests', category: 'Leave Management' },
  { permission: 'leave:reject', description: 'Reject leave requests', category: 'Leave Management' },
  { permission: 'leave:revoke', description: 'Revoke leave requests', category: 'Leave Management' },
  { permission: 'leave:manage_all', description: 'Manage all leave requests', category: 'Leave Management' },
  { permission: 'attestation:create', description: 'Create attestation requests', category: 'Attestation Management' },
  { permission: 'attestation:read', description: 'View attestation requests', category: 'Attestation Management' },
  { permission: 'attestation:approve', description: 'Approve attestation requests', category: 'Attestation Management' },
  { permission: 'attestation:reject', description: 'Reject attestation requests', category: 'Attestation Management' },
  { permission: 'attestation:generate', description: 'Generate attestation certificates', category: 'Attestation Management' },
  { permission: 'attestation:revoke', description: 'Revoke attestation requests', category: 'Attestation Management' },
  { permission: 'attestation:delete', description: 'Delete attestation requests', category: 'Attestation Management' },
  { permission: 'attestation:manage_all', description: 'Manage all attestation requests', category: 'Attestation Management' },
  { permission: 'request:create', description: 'Create custom requests', category: 'Custom Request Management' },
  { permission: 'request:read', description: 'View custom requests', category: 'Custom Request Management' },
  { permission: 'request:approve', description: 'Approve custom requests', category: 'Custom Request Management' },
  { permission: 'request:reject', description: 'Reject custom requests', category: 'Custom Request Management' },
  { permission: 'request:revoke', description: 'Revoke custom requests', category: 'Custom Request Management' },
  { permission: 'request:delete', description: 'Delete custom requests', category: 'Custom Request Management' },
  { permission: 'request:manage_all', description: 'Manage all custom requests', category: 'Custom Request Management' },
  { permission: 'department:create', description: 'Create departments', category: 'Department Management' },
  { permission: 'department:read', description: 'View departments', category: 'Department Management' },
  { permission: 'department:update', description: 'Update departments', category: 'Department Management' },
  { permission: 'department:delete', description: 'Delete departments', category: 'Department Management' },
  { permission: 'department:manage_all', description: 'Manage all departments', category: 'Department Management' },
  { permission: 'salary:create', description: 'Create salary records', category: 'Salary Management' },
  { permission: 'salary:read', description: 'View salary information', category: 'Salary Management' },
  { permission: 'salary:update', description: 'Update salary information', category: 'Salary Management' },
  { permission: 'salary:delete', description: 'Delete salary records', category: 'Salary Management' },
  { permission: 'salary:manage_all', description: 'Manage all salary records', category: 'Salary Management' },
  { permission: 'task:create', description: 'Create tasks', category: 'Task Management' },
  { permission: 'task:read', description: 'View own tasks', category: 'Task Management' },
  { permission: 'task:update', description: 'Update tasks', category: 'Task Management' },
  { permission: 'task:delete', description: 'Delete tasks', category: 'Task Management' },
  { permission: 'task:read_all', description: 'View all tasks', category: 'Task Management' },
  { permission: 'task:manage_all', description: 'Manage all tasks', category: 'Task Management' },
  { permission: 'reward:read', description: 'View rewards', category: 'Reward Management' },
  { permission: 'reward:set_quota', description: 'Set task quota', category: 'Reward Management' },
  { permission: 'reward:set_bonus', description: 'Set bonus tiers', category: 'Reward Management' },
  { permission: 'reward:manage_all', description: 'Manage all rewards', category: 'Reward Management' },
  { permission: 'project:create', description: 'Create projects', category: 'Project Management' },
  { permission: 'project:read', description: 'View projects', category: 'Project Management' },
  { permission: 'project:update', description: 'Update projects', category: 'Project Management' },
  { permission: 'project:delete', description: 'Delete projects', category: 'Project Management' },
  { permission: 'project:set_quota', description: 'Set monthly quotas for contributors', category: 'Project Management' },
  { permission: 'project:manage_rewards', description: 'Calculate and manage project rewards', category: 'Project Management' },
  { permission: 'project:manage_all', description: 'Full project management access', category: 'Project Management' },
  { permission: 'system:config', description: 'Configure system settings', category: 'System' },
  { permission: 'system:backup', description: 'Perform system backups', category: 'System' },
  { permission: 'system:logs', description: 'View system logs', category: 'System' },
  { permission: 'system:monitoring', description: 'Access system monitoring', category: 'System' },
  { permission: 'reports:view', description: 'View reports', category: 'Reports' },
  { permission: 'reports:generate', description: 'Generate reports', category: 'Reports' },
  { permission: 'reports:export', description: 'Export reports', category: 'Reports' },
  { permission: 'dashboard:view', description: 'View dashboard', category: 'Dashboard' },
  { permission: 'dashboard:admin', description: 'Access admin dashboard', category: 'Dashboard' },
  { permission: 'profile:view', description: 'Access my profile page', category: 'Page Access' },
  { permission: 'remote_work:access', description: 'Access remote work page', category: 'Page Access' },
  { permission: 'notification:view', description: 'Access notifications page', category: 'Page Access' },
  { permission: 'notification_settings:manage', description: 'Access notification settings page', category: 'Page Access' },
];

export const ALL_PERMISSION_NAMES = ALL_PERMISSIONS.map((perm) => perm.permission);

export const ROLE_DEFAULT_PERMISSIONS = {
  admin: ALL_PERMISSION_NAMES,
  manager: [
    'user:read',
    'user:update',
    'attendance:create',
    'attendance:read',
    'attendance:update',
    'attendance:export',
    'attendance:manage_all',
    'leave:create',
    'leave:read',
    'leave:update',
    'leave:approve',
    'leave:reject',
    'leave:manage_all',
    'attestation:read',
    'attestation:approve',
    'attestation:reject',
    'attestation:generate',
    'attestation:manage_all',
    'request:read',
    'request:approve',
    'request:reject',
    'request:revoke',
    'request:manage_all',
    'department:read',
    'department:update',
    'salary:read',
    'salary:manage_all',
    'task:create',
    'task:read',
    'task:update',
    'task:delete',
    'task:read_all',
    'task:manage_all',
    'reward:read',
    'reward:set_quota',
    'reward:set_bonus',
    'reward:manage_all',
    'project:create',
    'project:read',
    'project:update',
    'project:delete',
    'project:set_quota',
    'project:manage_rewards',
    'project:manage_all',
    'reports:view',
    'reports:generate',
    'reports:export',
    'dashboard:view',
  ],
  employee: [
    'attendance:read',
    'leave:create',
    'leave:read',
    'leave:update',
    'salary:read',
    'attestation:create',
    'attestation:read',
    'request:create',
    'request:read',
    'task:read',
    'task:update',
    'reward:read',
    'project:read',
    'dashboard:view',
    'profile:view',
    'remote_work:access',
    'notification:view',
    'notification_settings:manage',
  ],
};

export const getRoleBasedPermissions = (role) => {
  const normalizedRole = String(role || '').toLowerCase();
  return ROLE_DEFAULT_PERMISSIONS[normalizedRole] || [];
};

export const PAGE_PERMISSIONS = {
  dashboard: ['dashboard:view', 'dashboard:admin'],
  users: ['user:read'],
  departments: ['department:read'],
  attendance_management: ['attendance:manage_all'],
  salary_management: ['salary:manage_all'],
  all_requests: ['leave:manage_all', 'attestation:manage_all', 'request:manage_all'],
  permissions: ['user:manage_permissions'],
  settings: ['system:config'],
  my_profile: ['profile:view'],
  my_requests: ['leave:read', 'attestation:read', 'request:read'],
  my_attendance: ['attendance:read'],
  my_salary: ['salary:read'],
  tasks: ['task:read_all', 'task:manage_all'],
  projects: ['project:manage_all'],
  rewards: ['reward:manage_all', 'reward:set_quota', 'reward:set_bonus'],
  my_tasks: ['task:read'],
  my_rewards: ['reward:read'],
  remote_work: ['remote_work:access'],
  notifications: ['notification:view'],
  notification_settings: ['notification_settings:manage'],
};
